<template>
  <div class="htqd-container">
    <el-row>
      <el-col class="tcf-row">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              合同签订
            </div>
            <div class="card-content" >
              <el-form :model="eForm" :rules="eRules" ref="eForm" label-width="100px">
                <el-form-item label="签订客户" prop="clientid">
                  <el-select v-model="eForm.clientid" style="width:240px" placeholder="请选择" clearable filterable>
                    <el-option
                      v-for="item in clientList"
                      :key="item.client_id"
                      :label="item.client_name+'（'+item.tel+'）'"
                      :value="item.client_id">
                      <span style="float: left">{{ item.client_name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.tel }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="签订日期" prop="time">
                  <el-date-picker
                    v-model="eForm.time"
                    type="date"
                    style="width:240px"
                    format="yyyy年MM月dd日"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="签订地点" prop="address">
                  <el-input v-model="eForm.address" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="签订合同" prop="contractid">
                  <el-select v-model="eForm.contractid" style="width:350px" placeholder="请选择" clearable filterable>
                    <el-option
                      v-for="item in contractList"
                      :key="item.contract_id"
                      :label="item.name+'（'+item.code+'）'"
                      :value="item.content_id">
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="客户全称" prop="allname">
                  <el-col :span="4">
                    <el-input placeholder="地区" @input="setAllName" v-model="eForm.allnameArea"></el-input>
                  </el-col>
                  <el-col :span="1" style="text-align: center">-</el-col>
                  <el-col :span="4">
                    <el-input placeholder="姓名" @input="setAllName" v-model="eForm.allnameTxt"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="代理品牌" prop="brand">
                  <el-select v-model="eForm.brand" style="width:100%" multiple placeholder="请选择">
                    <el-option
                      v-for="item in brandList"
                      :key="item.brand_id"
                      :label="item.brand_name"
                      :value="item.brand_id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="展厅负责" prop="groupId">
                  <el-select v-model="eForm.groupId" placeholder="请选择">
                    <el-option
                      v-for="item in groupList"
                      :key="item.dGroupid"
                      :label="item.dAbbname"
                      :value="item.dGroupid">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="合同原件" prop="imgids">
                  <MultiImg :limit="9" :size="'sm'" ref="img" v-model="eForm.imgids" />
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                  <el-input type="textarea" v-model="eForm.remark" maxlength="300"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="loading" @click="submitForm('eForm')">立即提交</el-button>
                  <el-button @click="resetForm('eForm')">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getClientList, getContractList, getBrandList, signContract, getGroup} from '@/api/work'
import MultiImg from '@/components/upload/MultiImg'

export default {
  name: 'htqd',
  computed: {
    user: getUser
  },
  components: {
    MultiImg
  },
  data() {
    return {
      loading: false,
      clientList: [],
      contractList: [],
      brandList: [],
      groupList: [],
      eForm: {
        clientid: null,
        time: '',
        address: '',
        contractid: null,
        allname: '',
        brand: [],
        imgids: [],
        remark: '',
        groupId: '',
        allnameArea: '',
        allnameTxt: ''
      },
      eRules: {
        clientid: [{ required: true, message: '请选择要签订的客户', trigger: 'change' }],
        time: [{ required: true, message: '请选择签订日期', trigger: 'change' }],
        address: [{ required: true, message: '请输入签订地点', trigger: 'blur' }],
        contractid: [{ required: true, message: '请选择签订合同', trigger: 'change' }],
        allname: [{ required: true, message: '请输入客户全称', trigger: 'blur' }],
        brand: [{ required: true, message: '请选择代理品牌，至少一个品牌', trigger: 'change' }],
        imgids: [{ required: true, message: '请上传合同原件图片', trigger: 'change' }],
        groupId: [{ required: true, message: '请选择展厅负责组织', trigger: 'change' }]
      }

    }
  },
  created() {
    this.getClientList()
    this.getContractList()
    this.getBrandList()
    this.getGroup()
  },
  methods: {
    setAllName() {
      if (this.eForm.allnameArea !== null && this.eForm.allnameArea !== '' && this.eForm.allnameArea !== undefined && this.eForm.allnameTxt !== null && this.eForm.allnameTxt !== '' && this.eForm.allnameTxt !== undefined && '' !== this.eForm.allnameTxt.trim() && '' !== this.eForm.allnameArea.trim()) {
        this.eForm.allname = this.eForm.allnameArea + '-' + this.eForm.allnameTxt
      } else {
        this.eForm.allname = ''
      }
    },
    getClientList() {
      getClientList({ userid: this.user.dUserid, page: 1, limit: 999999999, groupid: 2 }).then(response => {
        this.clientList = response.data
      }).catch(() => {})
    },
    getContractList() {
      getContractList({ page: 1, limit: 999999999 }).then(response => {
        this.contractList = response.data
      }).catch(() => {})
    },
    getBrandList() {
      getBrandList().then(response => {
        this.brandList = response.data
      }).catch(() => {})
    },
    getGroup() {
      getGroup().then(response => {
        this.groupList = response.data
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.loading) {
            this.loading = true
            const data = {
              userid: this.user.dUserid,
              clientid: this.eForm.clientid,
              time: this.eForm.time,
              address: this.eForm.address,
              contractid: this.eForm.contractid,
              allname: this.eForm.allname,
              brandStr: this.eForm.brand.join(','),
              imgStr: this.eForm.imgids.join(','),
              remark: this.eForm.remark,
              exGroup: this.eForm.groupId
            }
            signContract(data).then(response => {
              this.$message({
                message: '客户合同签订成功',
                type: 'success'
              })
              this.eForm.allnameArea = ''
              this.eForm.allnameTxt = ''
              this.resetForm(formName)
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.eForm.imgids = []
      this.$refs.img.clearMultiImg()
    }
  }

}
</script>
